<script>
  import { Pie } from 'vue-chartjs'
  import {createChartData, createChartOptions} from './chartTheme'

  export default {
    extends: Pie,
    props: {
      chartData: {
        type: Object,
        default: () => ({})
      },  
      options: {
        type: Object,
        default: () => ({})
      },        
    },       
    mounted () {        
      this.render()
    },
    watch: {
      chartData: function() {        
        this.render()
      },
      options: function() {
        this.render()
      },
    }, 
    methods: {
      render() {
        this.renderChart(createChartData(this.chartData), createChartOptions('pie', this.options))
      }
    }
  }
</script>
